import { render } from "./ImagePresenter.vue?vue&type=template&id=ab783734&scoped=true"
import script from "./ImagePresenter.vue?vue&type=script&lang=js"
export * from "./ImagePresenter.vue?vue&type=script&lang=js"

import "./ImagePresenter.vue?vue&type=style&index=0&id=ab783734&scoped=true&lang=css"

import exportComponent from "/builds/alex-yonge-photography/alex-yonge-photographs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab783734"]])

export default __exports__